module.exports = __webpack_public_path__ + "static/media/chat.1182fbfb.svg";